export default "__VITE_ASSET__6a58ed09__"